import React, { useState, useEffect } from 'react';
import { styled } from '@mui/material/styles';
import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import CardMedia from '@mui/material/CardMedia';
import CardContent from '@mui/material/CardContent';
import CardActions from '@mui/material/CardActions';
import Collapse from '@mui/material/Collapse';
import Avatar from '@mui/material/Avatar';
import { Icon } from '@iconify/react';
import IconButton, { IconButtonProps } from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import { Menu, MenuItem } from '@mui/material';
import { red } from '@mui/material/colors';
import { makeStyles } from '@mui/styles';
import FavoriteIcon from '@mui/icons-material/Favorite';
import FavoriteBorderOutlinedIcon from '@mui/icons-material/FavoriteBorderOutlined';
import ShareIcon from '@mui/icons-material/Share';
import RepeatIcon from '@mui/icons-material/Repeat';
import PublicIcon from '@mui/icons-material/Public';
import HomeIcon from '@mui/icons-material/Home';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import moment from 'moment';
import 'moment/locale/ar';
import 'moment/locale/fr';
import axios from 'axios';
import { useTranslation } from 'react-i18next';
import secureLocalStorage from 'react-secure-storage';
import ReadMore from './ReadMore';

const useStyles = makeStyles((theme) => ({
  CardContainer: {
    width: 500,
    '@media (max-width:650px)': {
      width: '90%'
    }
  },
  CardAction: {
    justifyContent: 'space-between',
    padding: '10px 20px'
  },
  CardButton: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    minWidth: 50
  },
  subTitle: {
    fontSize: '12px',
    marginLeft: '5px'
  },
  divider: {
    height: '1px',
    width: '100%',
    backgroundColor: 'lightgray'
  }
}));

export default function PostCard({
  row,
  likeFunction,
  shareFunction,
  deleteFunction,
  data,
  setData
}) {
  const classes = useStyles();
  const [expanded, setExpanded] = useState(false);
  const [anchor, setAnchor] = useState(null);
  const [liked, setLiked] = useState(null);
  const [t, i18n] = useTranslation();

  const isMenuOpen = Boolean(anchor);
  const openMenu = (event) => {
    setAnchor(event.currentTarget);
  };

  const closeMenu = () => {
    setAnchor(null);
  };

  const API_ENDPOINT = process.env.REACT_APP_BASE_URL;
  const timeAgo = (time) => {
    const lang = localStorage.getItem('lang');
    if (lang !== 'العربية') {
      moment.locale('fr');
    } else {
      moment.locale('ar');
    }
    const timeago = moment(time).fromNow();
    return timeago;
  };

  const deletePost = (ID) => {
    const token = localStorage.getItem('access');
    const API_ENDPOINT = process.env.REACT_APP_BASE_URL;
    const body = { pk_post: ID };
    axios({
      method: 'delete',
      url: `${API_ENDPOINT}/api/delete-post-from-actuality/`,
      headers: { Authorization: `Bearer ${token}` },
      data: body
    })
      .then((res) => {
        console.log('delete post ID -->', res.data);
        const newDataList = data.filter((c) => c.id !== ID);
        setData(newDataList);
      })
      .catch((err) => {
        console.log('err', err);
      });
  };
  const like = (value) => {
    setLiked(value);
    likeFunction(row.id);
    if (!liked) {
      row.total_likes += 1;
    } else if (liked && row.total_likes > 0) {
      row.total_likes -= 1;
    }
  };

  useEffect(() => {
    if (row.is_liked_by_current_user === true) {
      setLiked(true);
    } else {
      setLiked(false);
    }
  }, [row.is_liked_by_current_user]);

  return (
    <Card className={classes.CardContainer}>
      <CardHeader
        style={{ marginBottom: '10px' }}
        avatar={
          <Avatar
            sx={{ bgcolor: red[500] }}
            src={`${API_ENDPOINT}${row.created_by_photo}`}
            aria-label="recipe"
          />
        }
        action={
          <>
            {row.is_post_owner && (
              <>
                <IconButton aria-label="settings" onClick={openMenu}>
                  <MoreVertIcon />
                </IconButton>
                <Menu id="basic-menu" anchorEl={anchor} open={isMenuOpen} onClose={closeMenu}>
                  <MenuItem
                    onClick={() => {
                      deletePost(row.id);
                      closeMenu();
                    }}
                  >
                    <Icon icon="mdi:earth" width={20} style={{ marginRight: '10px' }} />
                    {t('DeletePost')}
                  </MenuItem>
                </Menu>
              </>
            )}
          </>
        }
        title={row.created_by_name}
        subheader={
          <div className={classes.CardButton}>
            {row.share_with === 'public' && (
              <PublicIcon style={{ color: 'grey', fontSize: '14px' }} />
            )}
            {row.share_with === 'creche' && (
              <HomeIcon style={{ color: 'grey', fontSize: '14px' }} />
            )}
            {row.share_with === 'class' && <HomeIcon style={{ color: 'grey', fontSize: '14px' }} />}
            <Typography variant="body2" className={classes.subTitle}>
              {timeAgo(row.created_at)}
            </Typography>
          </div>
        }
      />
      {row.post_shared_from.id ? (
        <>
          <div className={classes.divider} />
          <CardHeader
            style={{ margin: '10px', padding: '0px', paddingLeft: '30px' }}
            avatar={
              <Avatar
                sx={{ bgcolor: red[500] }}
                src={`${API_ENDPOINT}${row.post_shared_from.created_by_photo}`}
                aria-label="recipe"
              />
            }
            title={row.post_shared_from.created_by_name}
            subheader={
              <div className={classes.CardButton}>
                {row.post_shared_from.share_with === 'public' && (
                  <PublicIcon style={{ color: 'grey', fontSize: '14px' }} />
                )}
                {row.post_shared_from.share_with === 'creche' && (
                  <HomeIcon style={{ color: 'grey', fontSize: '14px' }} />
                )}
                {row.post_shared_from.share_with === 'class' && (
                  <HomeIcon style={{ color: 'grey', fontSize: '14px' }} />
                )}
                <Typography variant="body2" className={classes.subTitle}>
                  {timeAgo(row.post_shared_from.created_at)}
                </Typography>
              </div>
            }
          />
          {row.post_shared_from.text !== null && row.post_shared_from.text !== ' ' ? (
            <div style={{ padding: '0px 35px', paddingBottom: '10px' }}>
              <ReadMore nbrCara={100} colorText="#252525">
                {row.post_shared_from.text}
              </ReadMore>
            </div>
          ) : null}
        </>
      ) : null}
      {row.media !== '/media/None' &&
        row.media !== `${API_ENDPOINT}/media/null` &&
        row.media !== null && (
          <CardMedia
            component="img"
            image={row.media}
            alt="Paella dish"
            style={{ height: 400, width: '100%' }}
          />
        )}
      {row.text !== null && (
        <CardContent>
          <ReadMore nbrCara={100} colorText="#252525">
            {row.text}
          </ReadMore>
        </CardContent>
      )}
      <CardActions className={classes.CardAction}>
        <div className={classes.CardButton}>
          <IconButton aria-label="add to favorites" onClick={() => like(!liked)}>
            {liked ? <FavoriteIcon style={{ color: 'red' }} /> : <FavoriteBorderOutlinedIcon />}
          </IconButton>
          <Typography variant="body2" color="text.secondary">
            {row.total_likes}
          </Typography>
        </div>
        <div className={classes.CardButton}>
          <IconButton aria-label="share" onClick={shareFunction}>
            <RepeatIcon />
          </IconButton>
          <Typography variant="body2" color="text.secondary">
            {row.num_shares}
          </Typography>
        </div>
        <div className={classes.CardButton}>
          <Typography variant="body2" color="text.secondary">
            {row.total_views}
          </Typography>
          <Typography style={{ margin: '0px 5px' }} variant="body2" color="text.secondary">
            {t('vue')}
          </Typography>
        </div>
      </CardActions>
    </Card>
  );
}
